export default "__VITE_ASSET__8211b98d__"